import type { Control, FieldValue, FieldValues } from 'react-hook-form'
import { Controller } from 'react-hook-form'
import type { DropdownProps } from './Dropdown'
import Dropdown from './Dropdown'

interface HFDropdownProps extends DropdownProps {
  name: string
  control: Control<FieldValue<FieldValues>>
}

function HFDropdown({ name, control, required, onChange, ...rest }: HFDropdownProps) {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => {
        return (
          <div className='field'>
            <Dropdown
              {...rest}
              selectedOption={field.value}
              onChange={option => {
                field.onChange(option)
                onChange(option)
              }}
              required={required}
              error={fieldState.invalid}
            />
            {required && fieldState.invalid && <p className='error-label'>{fieldState.error?.message}</p>}
          </div>
        )
      }}
    />
  )
}

export default HFDropdown
